// @ts-nocheck
import React, { useState, useMemo } from "react";
import { edit_icon } from "../../../../assets/img";
import Select from "react-select";
import { daysList } from "../../../StaticData";
import { post } from "../../../../Services/ApiHandler";
import { URLS } from "../../../../Services/Constant";
import { toast } from "react-toastify";

const EditSlot = ({
  ref,
  viewOnly,
  currentSlot,
  customStyles,
  availableSlots,
  data,
  setData,
  slotId,
  handleSlotSubmit,
  slotStatus,
  setSlotObj,
  slot_id,
  viewPrices,
}) => {
  const [edititable, setEditable] = useState(slotId === "add");
  const slot_timing = useMemo(
    () =>
      (availableSlots ?? [])
        .filter((item) => item?.label === data?.slotType?.label)
        .map((item) => ({ value: item?.id, label: item?.timeslot_type })),
    [availableSlots, data?.slotType?.label],
  );

  // eslint-disable-next-line no-unused-vars
  const slot_durations = useMemo(() => {
    const seen = new Set();
    return (availableSlots ?? []).filter((item) => {
      if (seen.has(item?.label)) return false;
      seen.add(item?.label);
      return true;
    });
  }, [availableSlots]);

  const handleChange = (name, val) => {
    if (viewOnly) return;
    if (name === "samePrice") {
      setData((prev) => ({
        ...prev,
        same_price: prev.same_price?.includes(val)
          ? prev.same_price?.filter((item) => item !== val)
          : [...prev.same_price, val],
      }));
    } else {
      setData((prev) => ({ ...prev, [name]: val }));
    }
  };

  // console.log("dataSlot", data);

  const handleStatus = async () => {
    let payload = {
      price_id: slot_id,
    };
    // console.log("payload-->status", payload);
    let res = await post(URLS.PROPERTY_ROOM_STATUS_MASTER, payload);
    // console.log("status_res", res);
    if (res?.status == "success") {
      viewPrices?.();

      toast.success(res?.message);
      setSlotObj((prev) => ({
        ...prev,
        [slot_id]: res?.updated_status,
      }));
    }
  };

  return (
    <div ref={ref} className=" mt-4">
      <div className="slot-box  rounded-4">
        <div className=" d-flex ac-jb ">
          {slotId !== "add" && (
            <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 mb-1">
              Slot {data?.sno} <span className="f4">({data?.name})</span>
            </p>
          )}

          {slotId !== "add" && !viewOnly && (
            <div className="d-flex ac-jb col-md-2">
              <button
                className={`${
                  !slotStatus ? "deactive-btn" : "active-btn"
                } border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
                onClick={() => handleStatus()}
              >
                {!slotStatus ? "De-active" : "Active"}
              </button>
              <button
                onClick={() => setEditable(!edititable)}
                className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 cust-btn "
              >
                <img src={edit_icon} className="edit-btn" alt="" />
                <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 my-2">
                  {!edititable ? "Edit" : "Cancel"}
                </p>
              </button>
            </div>
          )}
        </div>
        <div className="d-flex flex-wrap gap-5 mt-4 col-md-12">
          <div className="col-md-5 ">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Slot Type
            </p>
            <div className="col-md-12 d-flex ac-jb">
              <div className="col-md-5">
                <Select
                  isDisabled={slotId !== "add"}
                  options={slot_durations}
                  value={data?.slotType}
                  onChange={(e) => {
                    handleChange("slotType", e);
                    handleChange("slotTime", null);
                  }}
                  placeholder="Select "
                  styles={customStyles}
                />
              </div>
              <div className="col-md-5">
                <Select
                  isDisabled={slotId !== "add"}
                  options={slot_timing}
                  onChange={(e) => {
                    handleChange("slotTime", e);
                  }}
                  value={data?.slotTime}
                  placeholder="Select "
                  styles={customStyles}
                />
              </div>
            </div>
          </div>
          <div className="col-md-5"></div>
          <div className={`col-md-5 ${!edititable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Properties Price
            </p>
            <input
              className="input-box"
              name="propPrice"
              value={data?.propPrice}
              // value={data?.propPrice ? Number(data?.propPrice).toFixed(0) : ""}
              readOnly={!edititable}
              onChange={(e) => handleChange("propPrice", e.target.value)}
              type="number"
              placeholder="Properties Price"
            />
          </div>
          <div className={`col-md-5 ${!edititable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Vow Commission
            </p>
            <input
              className="input-box"
              name="vowCommission"
              value={data?.vowCommission}
              // value={
              //   data?.vowCommission
              //     ? Number(data?.vowCommission).toFixed(0)
              //     : ""
              // }
              readOnly={!edititable}
              onChange={(e) => handleChange("vowCommission", e.target.value)}
              type="number"
              placeholder="Vow Commission"
            />
          </div>
          <div className={`col-md-5 ${!edititable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Property Extra Person Price
            </p>
            <input
              className="input-box"
              name="extraPrice"
              value={
                data?.extraPrice ? Number(data?.extraPrice).toFixed(0) : ""
              }
              readOnly={!edititable}
              onChange={(e) => handleChange("extraPrice", e.target.value)}
              type="number"
              placeholder="Property Extra Person Price"
            />
          </div>
          <div className={`col-md-5 ${!edititable ? "opacity-50" : ""}`}>
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Vow Extra Commission
            </p>
            <input
              className="input-box"
              name="extraCommission"
              value={data?.extraCommission}
              // value={
              //   data?.extraCommission
              //     ? Number(data?.extraCommission).toFixed(0)
              //     : ""
              // }
              readOnly={!edititable}
              onChange={(e) => handleChange("extraCommission", e.target.value)}
              type="number"
              placeholder="Vow Extra Commission"
            />
          </div>
          <div className="d-flex ac-jb">
            <div className={`col-md-5 ${!edititable ? "opacity-50" : ""}`}>
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
                Same Price On
              </p>
              <div className="d-flex gap-3 mt-3 ">
                {daysList.map((day, index) => {
                  if (day === currentSlot) {
                    return null;
                  }
                  return (
                    <span
                      onClick={() => {
                        if (edititable) {
                          handleChange("samePrice", day);
                        }
                      }}
                      className="d-flex ac-js gap-1"
                    >
                      <p
                        className={`slot-check${
                          data?.same_price?.includes(day) ? "" : "-off"
                        }`}
                      ></p>
                      <p className="f3 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-20 ">
                        {day?.substring(0, 3)}
                      </p>
                    </span>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        {!viewOnly && edititable && (
          <div className="d-flex ac-je my-4">
            <button
              onClick={handleSlotSubmit}
              className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
            >
              Submit
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditSlot;
